import { render, staticRenderFns } from "./WarehouseProductList.vue?vue&type=template&id=8f6ba502"
import script from "./WarehouseProductList.vue?vue&type=script&lang=js"
export * from "./WarehouseProductList.vue?vue&type=script&lang=js"
import style0 from "./WarehouseProductList.vue?vue&type=style&index=0&id=8f6ba502&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports